import React, { useEffect, useState } from "react";
import "./Skills.css";
import images from "../../images/index";

const Skills = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark"));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const imageSrc_github = isDarkMode ? images.github_dark : images.github_day;

  return (
    <section id="skills">
      <div className="skill-container">
        <div className="skill-text">
          <p>My Expertise are</p>
          <h2>Skills</h2>
        </div>
        <div className="skills">
          <figure>
            <img src={images.c} alt="C" style={{height:64,width:64}} />
            <figcaption>C</figcaption>
          </figure>
          <figure>
            <img src={images.cpp} alt="Cpp" />
            <figcaption>CPP</figcaption>
          </figure>
          <figure>
            <img src={images.csharp} alt="C#" style={{height:64,width:64}} />
            <figcaption>C#</figcaption>
          </figure>
          <figure>
            <img src={images.js} alt="JavaScript" />
            <figcaption>JavaScript</figcaption>
          </figure>
          <figure>
            <img src={images.typescript} alt="typescript" style={{height:64,width:64}} />
            <figcaption>Typescript</figcaption>
          </figure>
          <figure>
            <img src={images.python} alt="Python" style={{height:64,width:64}} />
            <figcaption>Python</figcaption>
          </figure>
          {/* <figure>
            <img src={images.html} alt="html" />
            <figcaption>HTML5</figcaption>
          </figure>
          <figure>
            <img src={images.css} alt="css" />
            <figcaption>CSS3</figcaption>
          </figure> */}
          <figure>
            <img src={images.tailwind} alt="Tailwind" style={{height:64,width:64}} />
            <figcaption>Tailwind CSS</figcaption>
          </figure>
          <figure>
            <img src={images.react} alt="React" style={{height:64,width:64}}/>
            <figcaption>React</figcaption>
          </figure>
          <figure>
            <img src={images.nextjs} alt="Next.js" style={{height:64,width:64}} />
            <figcaption>Next.js</figcaption>
          </figure>
          <figure>
            <img src={images.express} alt="Express" style={{height:64,width:64}} />
            <figcaption>Express</figcaption>
          </figure>
          <figure>
            <img src={images.node} alt="Node.js" style={{height:64,width:64}} />
            <figcaption>Node.js</figcaption>
          </figure>
          <figure>
            <img src={images.dotnet} alt="DotNET" style={{height:64,width:64}} />
            <figcaption>.NET</figcaption>
          </figure>
          <figure>
            <img src={images.mongodb} alt="MongoDB" style={{height:64,width:64}}/>
            <figcaption>MongoDB</figcaption>
          </figure>
          <figure>
            <img src={images.sql} alt="MySQL" style={{height:64,width:64}}/>
            <figcaption>MySQL</figcaption>
          </figure>
          <figure>
            <img src={images.sqlserver} alt="SQL Server" style={{height:64,width:64}} />
            <figcaption>SQL Server</figcaption>
          </figure>
          <figure>
            <img src={images.psql} alt="PostgreSQL" style={{height:64,width:64}} />
            <figcaption>PostgreSQL</figcaption>
          </figure>
          <figure>
            <img src={images.linux} alt="VS Code" />
            <figcaption>Linux</figcaption>
          </figure>
          <figure>
            <img src={imageSrc_github} alt="GitHub" />
            <figcaption>GitHub</figcaption>
          </figure>
          <figure>
            <img src={images.postman} alt="Postman" />
            <figcaption>Postman</figcaption>
          </figure>
          <figure>
            <img src={images.vscode} alt="VS Code" />
            <figcaption>VS Code</figcaption>
          </figure>
         
         
       
          <figure>
            <img src={images.azure} alt="Azure" style={{height:64,width:64}} />
            <figcaption>Azure</figcaption>
          </figure>
          <figure>
            <img src={images.docker} alt="Docker" style={{height:64,width:64}} />
            <figcaption>Docker</figcaption>
          </figure>
          
          <figure>
            <img src={images.vs} alt="Visual Studio" style={{height:64,width:64}} />
            <figcaption>Visual Studio</figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Skills;
